<template>
  <CRow>
     <CCol xs="12" lg="12">
        <CCard>
          <CCardHeader>
            Permission
          </CCardHeader>
          <CCardBody>
            <CTabs variant="pills" vertical>
              <CTab v-for="item in items" :key="item.module_name">
                <template slot="title">
                 {{ item.module_name }}
                </template>

                <div v-for="p in permission" :key="p.id">
                  <div v-if="item.module_name == p.module_name">
                    <input type="checkbox" id="mike" :value="`${p.id}`" v-model="form.permissions">
                    {{ p.name }}
                  </div>
                </div>
                      
              </CTab>
            </CTabs>
          </CCardBody>
          <CCardFooter>
            <CButton size="sm" variant="primary" color="success" class="ml-1" @click="assign_permission()" >Assign Permission</CButton>
          </CCardFooter>
        </CCard>
      </CCol>
      <alertmodal></alertmodal>
  </CRow>
</template>

<script>
import axios from 'axios'
import EventBus from '@/eventBus';

import roles from '@/services/roles'

import alertmodal from '@/views/alert/modal.vue';

const token = localStorage.getItem('token');

export default {
  name: '',
  components: { alertmodal},
  data(){
    return{
      form:{
        permissions:[],
      },
      items: [],
      permission: [],
      checked:[],
      collapse: false,
      tabs: [
        'Calculator',
        'Shopping cart',
        'Charts'
      ],
    }
  },

  created() {
      //this.loadData()
      this.loadChecked()
  },
  mounted (){
     this.loadData()
   },
   
  methods: {
    loadData() {
      roles.getModule()
      .then(res => {
          let getData = res
          this.items = getData.data
          this.permission = getData.permission
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    loadChecked() {
      roles.getViewPermission(this.$route.query.id)
      .then(res => {
          let getData = res.data
          for (var i = 0; i < getData.length; i++) {
            //console.log(getData[i].id);
            this.form.permissions.push(getData[i].id);
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })

    },
    assign_permission() {
        roles.assignPermissionToRole(this.$route.query.id,this.form)
        .then(res => {
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        })

    },
  }
}
</script>